import { Media } from '@backbone-one/contentful-client';
import { Card, CardBody } from '@heroui/react';
import Image from 'next/image';
import React from 'react';

type SavingsEquivalentCardProps = {
  title: string;
  body: string;
  image: Media;
};
export default function SavingsEquivalentCard({
  title,
  body,
  image,
}: SavingsEquivalentCardProps) {
  return (
    <Card
      classNames={{
        base: 'w-[234px] h-full md:h-auto border border-[var(--color-border-default)]',
        body: 'p-0',
      }}
    >
      <CardBody>
        <Image
          data-testid={`${title}-image`}
          alt={title}
          src={image.url}
          width={234}
          height={234}
          className="h-[234px]"
        />
        <div className="p-6">
          <p data-testid={`${title}-title`} className="text-2xl leading-8 pb-1">
            {title}
          </p>
          <p data-testid={`${title}-content`}>{body}</p>
        </div>
      </CardBody>
    </Card>
  );
}
